import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { GoogleMap, Marker } from '@react-google-maps/api'

const useStyles = makeStyles((theme) => ({
    mapContainer: {
        width: '100%',
        height: '100%',
        minHeight: '300px',
        border: '1px solid #dbdbdb',
        borderRadius: '4px',
        overflow: 'hidden',
        boxShadow: 'inset 0 1px 2px rgba(10,10,10,.1)',
    },
}))

const defaultCenter = {
    lat: -3.745,
    lng: -38.523
}

const DisplayLocation = props => {
    const classes = useStyles()
    const { location, className, style } = props

    return (
        <Box
            className={`${classes.mapContainer} ${className || ''}`}
            style={style}
        >
            <GoogleMap
                id="gmap"
                mapContainerStyle={{
                    height: "100%",
                    width: "100%"
                }}
                zoom={15}
                center={location ? location : defaultCenter}
            >
                {location && <Marker position={location} />}
            </GoogleMap>
        </Box>
    )
}

DisplayLocation.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    location: PropTypes.object
}

export default DisplayLocation
